<h3>Férias Especiais Judiciais</h3>

<ng-container *ngIf="exercicioSelecionado as exercicio">
    <app-cabecalho-funcional [exercicioSelecionado]="exercicio" [quantidadeDias]="dadosExercicio.quantidadeDias" [periodoAquisitivo]="dadosExercicio.periodoAquisitivo" [exibirPeriodoProgramacaoDisponivel]="false" [exibirTipoPeriodoAquisitivo]="true"></app-cabecalho-funcional>
</ng-container>

<p-steps [model]="itensWizard" [readonly]="true" [activeIndex]="wizardActiveIndex"></p-steps>

<ng-container *ngIf="wizardActiveIndex === 0">
    <div class="row">
        <div class="col-12 col-lg-6 mt-2">
            <div class="br-input" [class.danger]="campoExercicioInvalido('numeroProcesso')">
                <label for="numero-processo-jcp">Número do processo judicial (Obrigatório)</label>
                <input id="numero-processo-jcp" type="text" [(ngModel)]="dadosExercicio.numeroProcesso" maxlength="50" aria-describedby="numero-processo-jcp-ajuda" (input)="registrarAlteracao()" (blur)="marcarCampoExercicioTocado('numeroProcesso')" />
                <p id="numero-processo-jcp-ajuda" class="text-base mt-1">Informe até 50 caracteres, sem seis ou mais dígitos consecutivos iguais.</p>
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('numeroProcesso') && !campoExercicioObrigatorioNaoInformado('numeroProcesso')">Informe um número de processo judicial válido, com até 50 caracteres e sem seis ou mais dígitos consecutivos iguais.</p>
                <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('numeroProcesso')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mt-2">
            <div class="br-textarea" [class.danger]="campoExercicioInvalido('sentencaJudicial')">
                <label for="sentenca-judicial-jcp">Descrição resumida da sentença (Obrigatório)</label>
                <textarea id="sentenca-judicial-jcp" pInputTextarea [(ngModel)]="dadosExercicio.sentencaJudicial" rows="6" maxlength="300" aria-describedby="sentenca-judicial-jcp-contador" (input)="registrarAlteracao()" (blur)="marcarCampoExercicioTocado('sentencaJudicial')"></textarea>
                <p id="sentenca-judicial-jcp-contador" class="text-base mt-1" aria-live="polite">
                    <b>{{ dadosExercicio.sentencaJudicial.length }}</b>
                    de
                    <b>300</b>
                    caracteres
                </p>
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('sentencaJudicial') && !campoExercicioObrigatorioNaoInformado('sentencaJudicial')">A descrição resumida da sentença deve conter entre 10 e 300 caracteres.</p>
                <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('sentencaJudicial')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-2 mt-2">
            <div class="br-input" [class.danger]="campoExercicioInvalido('quantidadeDias')">
                <label for="quantidade-dias-jcp">Quantidade de Dias (Obrigatório)</label>
                <input id="quantidade-dias-jcp" type="number" min="1" max="90" step="1" [(ngModel)]="dadosExercicio.quantidadeDias" (input)="validarInputQuantidadeDias($event)" (blur)="marcarCampoExercicioTocado('quantidadeDias')" />
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('quantidadeDias') && !campoExercicioObrigatorioNaoInformado('quantidadeDias')">Informe uma quantidade inteira entre 1 e 90 dias.</p>
                <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('quantidadeDias')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>

        <div class="col-12 col-lg-3 mt-2">
            <div class="br-input" [class.danger]="campoExercicioInvalido('quantidadeMaximaParcelas')">
                <label for="quantidade-maxima-parcelas-jcp">Máximo de Parcelas Férias</label>
                <p-dropdown inputId="quantidade-maxima-parcelas-jcp" [options]="opcoesQuantidadeMaximaParcelas" [(ngModel)]="dadosExercicio.quantidadeMaximaParcelas" placeholder="Selecione" (onChange)="alterarQuantidadeMaximaParcelas()" (onBlur)="marcarCampoExercicioTocado('quantidadeMaximaParcelas')" [removeClearButton]="true"></p-dropdown>
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('quantidadeMaximaParcelas') && quantidadeMaximaParcelasRaioXInvalida">Para concessão de Raio-X, o máximo de parcelas deve ser exatamente 2.</p>
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('quantidadeMaximaParcelas') && !quantidadeMaximaParcelasRaioXInvalida && !campoExercicioObrigatorioNaoInformado('quantidadeMaximaParcelas')">
                    Selecione um valor entre 1 e
                    {{ limiteQuantidadeMaximaParcelas }} parcelas.
                </p>
                <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('quantidadeMaximaParcelas')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>

        <div class="col-12 col-lg-2 mt-2">
            <div class="br-input" [class.danger]="campoExercicioInvalido('periodoAquisitivo')">
                <label for="periodo-aquisitivo-jcp">Tipo de Aquisição de Férias</label>
                <p-dropdown inputId="periodo-aquisitivo-jcp" [options]="opcoesPeriodoAquisitivo" optionLabel="label" optionValue="value" [(ngModel)]="dadosExercicio.periodoAquisitivo" placeholder="Selecione" (onChange)="alterarPeriodoAquisitivo($event.value)" (onBlur)="marcarCampoExercicioTocado('periodoAquisitivo')" [removeClearButton]="true"></p-dropdown>
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('periodoAquisitivo') && !campoExercicioObrigatorioNaoInformado('periodoAquisitivo')">Selecione Ano Civil ou Período Aquisitivo.</p>
                <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('periodoAquisitivo')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>

        <div class="col-12 col-lg-2 mt-2">
            <div class="br-input">
                <label id="inicio-periodo-programacao-label">Início Período de Programação</label>
                <p class="mb-0" id="inicio-periodo-programacao" aria-labelledby="inicio-periodo-programacao-label">
                    {{ exercicioSelecionado?.dataInicioPeriodoProgramacao ?? "" | dataFormatada }}
                </p>
                <p class="mt-1" role="status" aria-live="polite" *ngIf="calculandoPeriodoProgramacao">Calculando o período de programação...</p>
                <p class="feedback danger" role="alert" *ngIf="erroCalculoPeriodoProgramacao">Não foi possível calcular o período de programação. Tente novamente.</p>
            </div>
        </div>

        <div class="col-12 col-lg-3 mt-2">
            <div class="br-input" [class.danger]="campoExercicioInvalido('dataFimPeriodoProgramacao')">
                <label for="fim-periodo-programacao-jcp">Fim Período de Programação{{ extraordinario ? " (Obrigatório)" : "" }}</label>
                <p *ngIf="!extraordinario" class="mb-0" id="fim-periodo-programacao" aria-labelledby="fim-periodo-programacao-label">
                    {{ dadosExercicio.dataFimPeriodoProgramacao | dataFormatada }}
                </p>
                <p-calendar *ngIf="extraordinario" appendTo="body" inputId="fim-periodo-programacao-jcp" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" [ngModel]="dataFimPeriodoProgramacaoCalendario" [showOtherMonths]="false" [disabled]="calculandoPeriodoProgramacao" (ngModelChange)="atualizarDataFimPeriodoProgramacao($event)" (onBlur)="finalizarDataFimPeriodoProgramacao($event)"></p-calendar>
                <p class="feedback danger" role="alert" *ngIf="campoExercicioInvalido('dataFimPeriodoProgramacao') && !campoExercicioObrigatorioNaoInformado('dataFimPeriodoProgramacao')">Informe uma data válida posterior ao início do período de programação.</p>
                <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('dataFimPeriodoProgramacao')">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        Campo obrigatório
                    </span>
                </p>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-12 col-lg-9">
            <p-checkbox [binary]="true" label="Declaro que a decisão judicial está registrada no SIGEPE Ação Judicial." [(ngModel)]="dadosExercicio.declaracaoAcaoJudicial" (onChange)="marcarCampoExercicioTocado('declaracaoAcaoJudicial'); registrarAlteracao()">
                <ng-template pTemplate="icon">
                    <span class="fas fa-check"></span>
                </ng-template>
            </p-checkbox>
            <p class="mt-1" *ngIf="campoExercicioObrigatorioNaoInformado('declaracaoAcaoJudicial')">
                <span class="feedback danger" role="alert">
                    <i class="fas fa-times-circle" aria-hidden="true"></i>
                    Campo obrigatório
                </span>
            </p>
        </div>
        <div class="col-12 col-lg-3">
            <p-checkbox [binary]="true" [(ngModel)]="dadosExercicio.extraordinario" [disabled]="calculandoPeriodoProgramacao" (onChange)="alterarExtraordinario()" label="Excepcional">
                <ng-template pTemplate="icon">
                    <span class="fas fa-check"></span>
                </ng-template>
            </p-checkbox>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="wizardActiveIndex === 1">
    <ng-template #conteudoInterrupcao let-parcela let-i="indice">
        <div class="row mt-2" *ngIf="parcela.selecionadaParaInterrupcao">
            <div class="col-12 col-lg-4">
                <div class="row">
                    <div #dsgovInterrupcaoField class="col-12 col-lg-6 mt-2 br-input" [ngClass]="(!parcela.dataInterrupcao && submetidoParcelas) || parcela.validacao.dataInterrupcaoInvalida || parcela.validacao.dataInterrupcaoForaPeriodoFerias ? 'danger' : ''">
                        <label [for]="'campo-data-interrupcao-' + i">Data da Interrupção (Obrigatório)</label>
                        <p-calendar
                            [inputId]="'campo-data-interrupcao-' + i"
                            [showIcon]="true"
                            icon="fas fa-calendar-alt"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2023:2100"
                            dateFormat="dd/mm/yy"
                            placeholder="dd/mm/aaaa"
                            [(ngModel)]="parcela.dataInterrupcao"
                            [minDate]="parcela.dataMinimaInterrupcao"
                            [maxDate]="dataMaximaInterrupcao(parcela)"
                            [defaultDate]="parcela.dataMinimaInterrupcao || undefined"
                            [showOtherMonths]="false"
                            (onSelect)="dataInterrupcaoChange(parcela)"
                            (onBlur)="blurDataInterrupcaoChange(parcela, $event)"
                            (onInput)="inputDataInterrupcaoChange(parcela, $event)"></p-calendar>
                        <p class="mt-1" *ngIf="!parcela.dataInterrupcao && submetidoParcelas">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                        <p class="mt-1" *ngIf="parcela.validacao.dataInterrupcaoInvalida">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Data inválida!
                            </span>
                        </p>
                        <p class="feedback danger" role="alert" *ngIf="parcela.validacao.dataInterrupcaoForaPeriodoFerias">
                            {{ getMsgDataInterrupcaoForaPeriodoFerias(parcela) }}
                        </p>
                    </div>
                    <div #dsgovInterrupcaoField class="col-12 col-lg-6 mt-2 br-input" [ngClass]="!parcela.motivoLegal && submetidoParcelas ? 'danger' : ''">
                        <label [for]="'campo-motivo-legal-' + i">Motivo Legal (Obrigatório)</label>
                        <p-dropdown [inputId]="'campo-motivo-legal-' + i" [options]="['Calamidade Pública', 'Comoção Interna', 'Convocação para Júri', 'Necessidade do Serviço', 'Serviço Militar ou Eleitoral']" [(ngModel)]="parcela.motivoLegal" placeholder="Selecione" [editable]="false" styleClass="mt-1" (onChange)="registrarAlteracao()">
                            <ng-template pTemplate="clearicon">
                                <span class="fas fa-times"></span>
                            </ng-template>
                            <ng-template pTemplate="dropdownicon">
                                <span class="fas fa-chevron-down"></span>
                            </ng-template>
                        </p-dropdown>
                        <p class="mt-1" *ngIf="!parcela.motivoLegal && submetidoParcelas">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div #dsgovInterrupcaoField class="col-12 col-lg-6 mt-2 br-input" [ngClass]="!parcela.documentoLegal.trim() && submetidoParcelas ? 'danger' : ''">
                        <label [for]="'campo-documento-legal-' + i">Documento Legal (Obrigatório)</label>
                        <input [id]="'campo-documento-legal-' + i" pInputText [(ngModel)]="parcela.documentoLegal" mask="00000" maxlength="5" (input)="registrarAlteracao()" />
                        <p class="mt-1" *ngIf="!parcela.documentoLegal.trim() && submetidoParcelas">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                    </div>
                    <div #dsgovInterrupcaoField class="col-12 col-lg-6 mt-2 br-input" [ngClass]="(!parcela.dataPublicacaoDocumentoLegal && submetidoParcelas) || parcela.validacao.dataPublicacaoInvalida ? 'danger' : ''">
                        <label [for]="'campo-data-publicacao-' + i">Data da Publicação (Obrigatório)</label>
                        <p-calendar [inputId]="'campo-data-publicacao-' + i" [showIcon]="true" icon="fas fa-calendar-alt" [monthNavigator]="true" [yearNavigator]="true" yearRange="2023:2100" dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa" [(ngModel)]="parcela.dataPublicacaoDocumentoLegal" [showOtherMonths]="false" (onSelect)="dataPublicacaoChange(parcela)" (onBlur)="blurDataPublicacaoChange(parcela, $event)" (onInput)="inputDataPublicacaoChange(parcela, $event)"></p-calendar>
                        <p class="mt-1" *ngIf="!parcela.dataPublicacaoDocumentoLegal && submetidoParcelas">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Campo obrigatório
                            </span>
                        </p>
                        <p class="mt-1" *ngIf="parcela.validacao.dataPublicacaoInvalida">
                            <span class="feedback danger" role="alert">
                                <i class="fas fa-times-circle" aria-hidden="true"></i>
                                Data inválida!
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="br-textarea col-12 col-lg-8 mt-2" [ngClass]="{ danger: (parcela.motivoLegal === 'Necessidade do Serviço' && !parcela.justificativaInterrupcao.trim() && submetidoParcelas) || parcela.validacao.justificativaInterrupcaoInvalida }">
                <label [for]="'textarea-justificativa-parcela-' + i">
                    Justificativa de interrupção da parcela
                    {{ parcela.motivoLegal === "Necessidade do Serviço" ? "(Obrigatório)" : "" }}
                </label>
                <textarea [id]="'textarea-justificativa-parcela-' + i" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" maxlength="300" [(ngModel)]="parcela.justificativaInterrupcao" maxlength="300" (input)="onJustificativaChangeInterrupcao($event, parcela)" (blur)="validarJustificativaInterrupcao(parcela)"></textarea>
                <div class="text-base mt-1">
                    <span class="limit" aria-live="polite">
                        <b>{{ parcela.justificativaInterrupcao.length }}</b>
                        de
                        <b>300</b>
                        caracteres digitados
                    </span>
                </div>
                <p class="mt-1" *ngIf="(parcela.motivoLegal === 'Necessidade do Serviço' && !parcela.justificativaInterrupcao.trim() && submetidoParcelas) || parcela.validacao.justificativaInterrupcaoInvalida">
                    <span class="feedback danger" role="alert">
                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                        {{ parcela.motivoLegal === "Necessidade do Serviço" ? msgJustificativaObrigatoria : msgJustificativaInvalida }}
                    </span>
                </p>
            </div>
        </div>
        <div class="row mt-2" *ngIf="!parcela.selecionadaParaInterrupcao && situacaoParcela(i).descricao === 'Interrompida'">
            <div class="col-12 col-lg-4" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal || parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                <div class="row" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal">
                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataInterrupcao">
                        <p class="label mb-1">Data da Interrupção</p>
                        <p class="mb-0">{{ parcela.dataInterrupcao | dataFormatada }}</p>
                    </div>
                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.motivoLegal">
                        <p class="label mb-1">Motivo Legal</p>
                        <p class="mb-0">{{ parcela.motivoLegal }}</p>
                    </div>
                </div>
                <div class="row" *ngIf="parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.documentoLegal">
                        <p class="label mb-1">Documento Legal</p>
                        <p class="mb-0">{{ parcela.documentoLegal }}</p>
                    </div>
                    <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataPublicacaoDocumentoLegal">
                        <p class="label mb-1">Data da Publicação</p>
                        <p class="mb-0">{{ parcela.dataPublicacaoDocumentoLegal | dataFormatada }}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-8">
                <div class="row" *ngIf="parcela.justificativaInterrupcao">
                    <div class="col-12 mt-2 br-input">
                        <p class="label mb-1">Justificativa de interrupção da parcela</p>
                        <p class="mb-0">{{ parcela.justificativaInterrupcao }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2" *ngIf="!parcela.selecionadaParaInterrupcao && parcelaPodeSerInterrompida(parcela)">
            <div class="col-12 text-right">
                <button [id]="'botao-interromper-parcela-' + i" pButton type="button" label="Interromper" class="botao-responsivo" (click)="selecionarParcelaParaInterromper(parcela)"></button>
            </div>
        </div>
        <div class="row mt-2" *ngIf="parcela.selecionadaParaInterrupcao">
            <div class="col-12 text-right">
                <button [id]="'botao-desistir-interromper-parcela-' + i" pButton type="button" label="Desistir" class="botao-responsivo" (click)="desistirSelecaoParcelaParaInterromper(parcela)"></button>
            </div>
        </div>
    </ng-template>
    <div class="row mt-2">
        <div class="col-12" *ngFor="let parcela of parcelas; let i = index; trackBy: trackByParcela">
            <ng-container *ngIf="parcela.geracao > 0">
                <h4 class="text-interactive mb-1">{{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}ª Parcela</h4>
                <section class="br-card">
                    <div class="card-content">
                        <div class="row" *ngIf="!parcela.selecionadaParaInterrupcao && situacaoParcela(i).descricao !== 'Interrompida'">
                            <div class="col-10 col-lg-2 mt-2 br-datetimepicker br-input" [class.danger]="campoParcelaInvalido(i, 'dataInicio')">
                                <label [attr.for]="'campo-data-inicio_' + i">Data de início (Obrigatório)</label>
                                <p-calendar
                                    appendTo="body"
                                    [inputId]="'campo-data-inicio_' + i"
                                    [showIcon]="true"
                                    icon="fas fa-calendar-alt"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="2023:2100"
                                    dateFormat="dd/mm/yy"
                                    placeholder="dd/mm/aaaa"
                                    [formControl]="parcela.dataInicioCalendarioControl"
                                    [minDate]="parcela.dataMinimaReprogramacao"
                                    [maxDate]="dataFimPeriodoProgramacaoMaximaCalendario"
                                    [defaultDate]="parcela.dataMinimaReprogramacao || undefined"
                                    [showOtherMonths]="false"
                                    (onSelect)="atualizarDataInicioParcela(i, $event)"
                                    (onBlur)="finalizarDataInicioParcela(i, $event)"></p-calendar>
                                <p class="mt-1" *ngIf="!parcela.dataInicio && submetidoParcelas">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && !campoParcelaObrigatorioNaoInformado(i, 'dataInicio') && !parcelaForaPeriodoProgramacao(i) && !periodoProgramacaoIndisponivel(i) && !parcelaSobreposta(i) && !parcelaForaDaOrdem(i)">Informe uma data de início válida.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && parcelaForaPeriodoProgramacao(i)">A data deve estar dentro do período de programação disponível.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && periodoProgramacaoIndisponivel(i)">Não foi possível identificar o período de programação para validar a data.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && parcelaSobreposta(i)">As parcelas estão com datas sobrepostas neste exercício de férias.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && parcelaForaDaOrdem(i)">A data de início deve respeitar a ordem cronológica das parcelas.</p>
                            </div>
                            <div class="col-12 col-lg-3 mt-2">
                                <label>Quantidade de dias</label>
                                <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                            </div>
                            <div class="col-12 col-lg-2 mt-2">
                                <label [for]="'campo-periodo-ferias_' + i">Data de Término</label>
                                <p class="mb-0" [id]="'campo-periodo-ferias_' + i">
                                    {{ dataFimParcela(i) | dataFormatada }}
                                </p>
                            </div>
                            <ng-container *ngIf="situacaoParcela(i) as situacao">
                                <div class="col-12 col-lg-2 mt-2 desktop-only" [style.visibility]="situacao.descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                                    <label>Situação</label>
                                    <p-tag [value]="situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + situacao.codigoCor + ' 100%,' + situacao.codigoCor + ' 100%)' }"></p-tag>
                                </div>
                            </ng-container>
                            <div class="col-12 col-lg-3 mt-2 text-right" *ngIf="permiteExcluirParcela(i)">
                                <p-button [id]="'botao-excluir-parcela_' + i" class="p-element" styleClass="m-2 circle" icon="fas fa-trash-alt" (click)="confirmarExcluirParcela(i)" title="Excluir Parcela" ariaLabel="Excluir parcela"></p-button>
                            </div>
                        </div>
                        <div class="row" *ngIf="parcela.selecionadaParaInterrupcao || situacaoParcela(i).descricao === 'Interrompida'">
                            <div class="col-12 col-lg-2 mt-2">
                                <p class="label mb-1">Período de Férias</p>
                                <p class="mb-0">
                                    {{ parcela.dataInicio | dataFormatada }} a
                                    {{ dataFimParcela(i) | dataFormatada }}
                                </p>
                            </div>
                            <div class="col-12 col-lg-3 mt-2">
                                <p class="label mb-1">Quantidade de dias</p>
                                <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                            </div>
                            <div class="col-12 col-lg-2 mt-2" [style.visibility]="situacaoParcela(i).descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                                <p class="label mb-1">Situação</p>
                                <ng-container *ngIf="situacaoParcela(i) as situacao">
                                    <p-tag [id]="'parcela-situacao-' + i" [value]="situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + situacao.codigoCor + ' 100%,' + situacao.codigoCor + ' 100%)' }"></p-tag>
                                </ng-container>
                            </div>
                            <div class="col-12 col-lg-5 mt-2 text-right" *ngIf="permiteExcluirParcela(i)">
                                <p-button [id]="'botao-excluir-parcela_' + i" class="p-element" styleClass="m-2 circle" icon="fas fa-trash-alt" (click)="confirmarExcluirParcela(i)" title="Excluir Parcela" ariaLabel="Excluir parcela"></p-button>
                            </div>
                        </div>
                        <ng-container *ngTemplateOutlet="conteudoInterrupcao; context: { $implicit: parcela, indice: i }"></ng-container>
                    </div>
                </section>
            </ng-container>
            <h4 *ngIf="parcela.geracao === 0" class="text-interactive mb-1">{{ parcela.ordem }}ª Parcela</h4>
            <section class="br-card" *ngIf="parcela.geracao === 0">
                <div class="card-content">
                    <div class="row" *ngIf="parcela.selecionadaParaInterrupcao || situacaoParcela(i).descricao === 'Interrompida'">
                        <div class="col-12 col-lg-2 mt-2">
                            <p class="label mb-1">Período de Férias</p>
                            <p class="mb-0">
                                {{ parcela.dataInicio | dataFormatada }} a
                                {{ dataFimParcela(i) | dataFormatada }}
                            </p>
                        </div>
                        <div class="col-12 col-lg-3 mt-2">
                            <p class="label mb-1">Quantidade de dias</p>
                            <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                        </div>
                        <div class="col-12 col-lg-2 mt-2" [style.visibility]="situacaoParcela(i).descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                            <p class="label mb-1">Situação</p>
                            <ng-container *ngIf="situacaoParcela(i) as situacao">
                                <p-tag [id]="'parcela-situacao-' + i" [value]="situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + situacao.codigoCor + ' 100%,' + situacao.codigoCor + ' 100%)' }"></p-tag>
                            </ng-container>
                        </div>
                    </div>

                    <div class="row" *ngIf="!parcela.selecionadaParaInterrupcao && situacaoParcela(i).descricao !== 'Interrompida'">
                        <div class="col-12 col-lg-2 mt-2">
                            <div class="br-input" [class.danger]="campoParcelaInvalido(i, 'dataInicio')">
                                <label [attr.for]="'parcela-data-inicio-' + i">Data de início (Obrigatório)</label>
                                <p-calendar
                                    appendTo="body"
                                    [inputId]="'parcela-data-inicio-' + i"
                                    [showIcon]="true"
                                    icon="fas fa-calendar-alt"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="2023:2100"
                                    dateFormat="dd/mm/yy"
                                    placeholder="dd/mm/aaaa"
                                    [formControl]="parcela.dataInicioCalendarioControl"
                                    [minDate]="parcela.dataMinimaReprogramacao"
                                    [maxDate]="dataFimPeriodoProgramacaoMaximaCalendario"
                                    [defaultDate]="parcela.dataMinimaReprogramacao || undefined"
                                    [showOtherMonths]="false"
                                    (onSelect)="atualizarDataInicioParcela(i, $event)"
                                    (onBlur)="finalizarDataInicioParcela(i, $event)"></p-calendar>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && !campoParcelaObrigatorioNaoInformado(i, 'dataInicio') && !parcelaForaPeriodoProgramacao(i) && !periodoProgramacaoIndisponivel(i) && !parcelaSobreposta(i) && !parcelaForaDaOrdem(i)">Informe uma data de início válida.</p>
                                <p class="mt-1" *ngIf="campoParcelaObrigatorioNaoInformado(i, 'dataInicio')">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && parcelaForaPeriodoProgramacao(i)">A data deve estar dentro do período de programação disponível.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && periodoProgramacaoIndisponivel(i)">Não foi possível identificar o período de programação para validar a data.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && parcelaSobreposta(i)">As parcelas estão com datas sobrepostas neste exercício de férias.</p>
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'dataInicio') && parcelaForaDaOrdem(i)">A data de início deve respeitar a ordem cronológica das parcelas.</p>
                            </div>
                        </div>

                        <div class="col-12 col-lg-3 mt-2">
                            <div class="br-input" [class.danger]="campoParcelaInvalido(i, 'quantidadeDias')">
                                <label [attr.for]="'parcela-dias-' + i">Quantidade de dias (Obrigatório)</label>
                                <input [id]="'parcela-dias-' + i" type="number" min="1" [attr.max]="quantidadeMaximaDiasParcela" step="1" [value]="parcela.quantidadeDias ?? ''" [disabled]="parcela.quantidadeDiasDesabilitada" (input)="atualizarQuantidadeDiasParcela(i, $event)" (change)="alterarQuantidadeDiasParcela(i)" (blur)="marcarCampoParcelaTocado(i, 'quantidadeDias')" />
                                <p class="feedback danger" role="alert" *ngIf="campoParcelaInvalido(i, 'quantidadeDias') && parcela.quantidadeDias !== null && parcela.quantidadeDias > 0">
                                    Informe uma quantidade inteira entre 1 e
                                    {{ quantidadeMaximaDiasParcela }} dias do exercício.
                                </p>
                                <p class="mt-1" *ngIf="!parcela.quantidadeDiasDesabilitada && (parcela.quantidadeDias === 0 || !submetidoParcelas) && parcela.quantidadeDias !== null && parcela.quantidadeDias < 1">
                                    <span class="feedback danger" role="alert">
                                        Informe uma quantidade inteira entre 1 e
                                        {{ quantidadeMaximaDiasParcela }} dias do exercício.
                                    </span>
                                </p>
                                <p class="mt-1" *ngIf="(parcela.quantidadeDias || !submetidoParcelas) && alocacaoDiasIncompleta">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        {{ msgAlocacaoSaldoDiasIncompleta }}
                                    </span>
                                </p>
                                <p class="mt-1" *ngIf="campoParcelaObrigatorioNaoInformado(i, 'quantidadeDias')">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        Campo obrigatório
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div class="col-12 col-lg-2 mt-2">
                            <p class="label mb-1">Data de término</p>
                            <p [id]="'parcela-fim-' + i" class="mb-0">
                                {{ dataFimParcela(i) | dataFormatada }}
                            </p>
                        </div>

                        <div class="col-12 col-lg-2 mt-2" [style.visibility]="situacaoParcela(i).descricao === 'Não Solicitada' ? 'hidden' : 'visible'">
                            <p class="label mb-1">Situação</p>
                            <ng-container *ngIf="situacaoParcela(i) as situacao">
                                <p-tag [id]="'parcela-situacao-' + i" [value]="situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + situacao.codigoCor + ' 100%,' + situacao.codigoCor + ' 100%)' }"></p-tag>
                            </ng-container>
                        </div>

                        <div class="col-lg-3 mt-2 text-right">
                            <p-button class="p-element" *ngIf="permiteExcluirParcela(i)" styleClass="m-2 circle" icon="fas fa-trash-alt" (click)="confirmarExcluirParcela(i)" title="Excluir Parcela"></p-button>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-12 col-lg-5 mt-2">
                            <p class="label mb-1">Adicionais de Férias</p>
                            <div class="d-flex align-items-center mt-1">
                                <p-checkbox [inputId]="'parcela-decimo-terceiro-' + i" label="Adiantamento 13º" [binary]="true" [(ngModel)]="parcela.adiantamentoDecimoTerceiro" [disabled]="true" [tabindex]="-1" aria-disabled="true" styleClass="p-checkbox-disabled">
                                    <ng-template pTemplate="icon">
                                        <span class="fas fa-check"></span>
                                    </ng-template>
                                </p-checkbox>
                            </div>
                            <div class="d-flex align-items-center mt-1">
                                <p-checkbox [inputId]="'parcela-adiantamento-' + i" label="Adiantamento Salarial" [binary]="true" [(ngModel)]="parcela.adiantamentoSalarial" [disabled]="true" [tabindex]="-1" aria-disabled="true" styleClass="p-checkbox-disabled">
                                    <ng-template pTemplate="icon">
                                        <span class="fas fa-check"></span>
                                    </ng-template>
                                </p-checkbox>
                            </div>
                            <div class="d-flex align-items-center mt-1" *ngIf="exibeAbonoPecuniario">
                                <p-checkbox [inputId]="'parcela-abono-' + i" label="Abono Pecuniário" [binary]="true" [(ngModel)]="parcela.abonoPecuniario" [disabled]="true" [tabindex]="-1" aria-disabled="true" styleClass="p-checkbox-disabled">
                                    <ng-template pTemplate="icon">
                                        <span class="fas fa-check"></span>
                                    </ng-template>
                                </p-checkbox>
                            </div>
                        </div>

                        <div class="col-12 col-lg-3 mt-2" *ngIf="parcela.adiantamentoSalarial">
                            <div class="br-input">
                                <label [attr.for]="'parcela-desconto-' + i">Parcelas de desconto</label>
                                <input [id]="'parcela-desconto-' + i" type="number" [value]="parcela.parcelasDesconto ?? ''" disabled aria-disabled="true" />
                            </div>
                        </div>
                    </div>

                    <ng-container *ngTemplateOutlet="conteudoInterrupcao; context: { $implicit: parcela, indice: i }"></ng-container>
                </div>
            </section>
        </div>
    </div>

    <div class="row mt-2" *ngIf="submetidoParcelas && quantidadeParcelasAtivas === 0">
        <div class="col-12">
            <p class="feedback danger" role="alert">Informe ao menos uma parcela para concluir a operação.</p>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-12">
            <p class="label mb-1">Declaração (Obrigatório)</p>
            <div class="d-flex align-items-center">
                <p-checkbox [binary]="true" [(ngModel)]="dadosExercicio.declaracao" (onChange)="marcarDeclaracaoTocada(); registrarAlteracao()" label="Declaro estar ciente de que os efeitos financeiros, se necessários, deverão ser processados manualmente sob responsabilidade do gestor.">
                    <ng-template pTemplate="icon">
                        <span class="fas fa-check"></span>
                    </ng-template>
                </p-checkbox>
            </div>
            <p class="mt-1" *ngIf="(submetidoParcelas || declaracaoTocada) && campoDeclaracaoNaoInformado()">
                <span class="feedback danger" role="alert">
                    <i class="fas fa-times-circle" aria-hidden="true"></i>
                    Campo obrigatório
                </span>
            </p>
        </div>
    </div>
</ng-container>
<div class="row mt-4">
    <div class="col text-left">
        <button aria-label="botão cancelar" id="botao-cancelar" pButton type="button" label="Cancelar" class="botao-responsivo" (click)="confirmarCancelarWizard()"></button>
    </div>
    <div class="col text-right">
        <button *ngIf="wizardActiveIndex != 0" aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="secondary mr-2 botao-responsivo" (click)="voltarWizard()"></button>
        <button aria-label="botão reprogramar" id="botao-reprogramar" pButton type="submit" *ngIf="wizardActiveIndex != 1" label="Avançar" class="primary botao-responsivo" (click)="avancarWizard()"></button>
        <button aria-label="botão reprogramar" id="botao-reprogramar" pButton type="submit" *ngIf="wizardActiveIndex == 1" label="Concluir" class="primary botao-responsivo" (click)="concluirWizard()"></button>
        <!--p-button (click)="showDialog()" icon="pi pi-external-link" label="Show"></p-button-->
    </div>
</div>
<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
